import { ClientFragment } from '@/modules/clients/graphql/fragments/generated/client';
import {
  ActionItemFragment,
  DashboardActionItemFragment,
} from '@/modules/tasks/features/actionItems/graphql/fragments/generated/ActionItem';
import {
  CreateActionItemInput,
  CreateClientInput,
  GroupedActionItemEdge,
  PaginatedActionItemsPayload,
  VisibilitySettingsInput,
} from '@/types/schema';

export enum ItemTypeEnum {
  File = 'FILE',
  Folder = 'FOLDER',
}

export type DashboardActionItemFragmentWithChildCount = DashboardActionItemFragment & {
  childCount: number;
};

export interface GroupedActionItem {
  groupByKey: GroupedActionItemEdge['groupByKey'];
  totalCount: PaginatedActionItemsPayload['totalCount'];
  pageInfo: PaginatedActionItemsPayload['pageInfo'];
  actionItems: DashboardActionItemFragmentWithChildCount[];
}

export interface FolderItem {
  id: string;
  name: string;
  visibilitySettings: VisibilitySettingsInput;
  type: ItemTypeEnum;
  count: number;
}

export enum ActionDialogsEnum {
  AddNewTask = 'ADD_NEW_TASK',
  DuplicateTask = 'DUPLICATE_TASK',
  ConvertTaskToSubtask = 'CONVERT_TASK_TO_SUBTASK',
  EditTask = 'EDIT_TASK',
  CreateFolder = 'CREATE_FOLDER',
  CreateProject = 'CREATE_PROJECT',
  EditProject = 'EDIT_PROJECT',
  DuplicateProject = 'DUPLICATE_PROJECT',
  DeleteProject = 'DELETE_PROJECT',
  DeleteTask = 'DELETE_TASK',
  CreateList = 'CREATE_LIST',
  EditList = 'EDIT_LIST',
  DuplicateList = 'DUPLICATE_LIST',
  DeleteList = 'DELETE_LIST',
  CreateSection = 'CREATE_SECTION',
  EditSection = 'EDIT_SECTION',
  MoveToSection = 'MOVE_TO_SECTION',
  DeleteSection = 'DELETE_SECTION',
  AddOrEditClient = 'ADD_OR_EDIT_CLIENT',
  DeleteClient = 'DELETE_CLIENT',
  AddClientContact = 'ADD_CLIENT_CONTACT',
  MoveTaskToList = 'MOVE_TASK_TO_LIST',
  MoveTaskToProject = 'MOVE_TASK_TO_PROJECT',
}

export type InViewDialogState = {
  dialog: ActionDialogsEnum;
  /**
   * used to fetch data when editing / moving a list
   */
  fileId?: string;
  /**
   * used to create a list in an existing stack
   *
   * used to fetch data when editing a stack
   */
  duplicateFromId?: string;
  duplicateFromFileId?: string;
  title?: string;
  /**
   * used to duplicate a task, project or list
   */
  folderId?: string;
  task?: ActionItemFragment | CreateActionItemInput;
  /**
   * used to pre-fill the client in the create project dialog
   */
  clientId?: string;
  /**
   * used to pre-fill the edit client form and for adding/updating client contacts
   */
  client?: ClientFragment | CreateClientInput;
  /**
   * used to pre-fill the edit client contact form
   */
  clientContactId?: string;
};
